import React from "react";
import Index from "./pages/Index";
import Preloader from "./layouts/Preloader";
import { LoadingProvider } from "./LoadingContext";
import "./i18n"; // Initialize i18n

//Css
import "./assets/css/style.css";
import "./assets/css/loader.scss";

const App = () => {
  // Preloader and Index render together inside LoadingProvider so that:
  // 1. API calls start immediately (no artificial gate)
  // 2. Preloader overlays as a visual splash while data loads in the background
  return (
    <div className="App app-entrance">
      <LoadingProvider>
        <Preloader />
        <Index />
      </LoadingProvider>
    </div>
  );
};

export default App;


